/*
 * @Author: tony.zhu
 * @Date: 2025-10-16 18:54:50
 * @LastEditTime: 2025-11-10 12:02:03
 * @LastEditors: tony.zhu
 * @Description:
 */

// import {
//     http
// } from "http/http";
// import {
//     API
// } from "http/api";
import DataType from '@/components/aiChat/utils/type'
import { Api } from '@/api'

export const commonMixin = {
  data() {
    return {
      pageInfo: {
        total: 0,
        pages: null,
        pageNum: 1,
        pageSize: 20,
        finished: false,
        isMorePage: null
      },
      dialogueList: []
    }
  },
  computed: {},
  methods: {
    async onInsertDialogue(data = {}) {
      try {
        const sourceValue = this.chatSourceType || this.$attrs.sourceType || this.$attrs.source || ''
        const params = {
          initPrompt: data.question,
          interviewEvaluateId: this.$attrs.interviewProp.interviewEvaluateId,
          resumeId: this.$attrs.interviewProp.resumeId
        }
        if (sourceValue === 'global' || sourceValue === 'wenshu') {
          params.source = sourceValue
        }
        const res = await Api.createSession(params)
        if (res.code === '0') {
          return Promise.resolve(res.data || '')
        }
      } catch (error) {
        console.log(error)
        if (DataType.isObject(error) && error.data && error.data.code === 401) {
          this.$emit('on-logout')
        }
      }
    },

    async onDeleteDialogue(id) {
      try {
        const res = await Api.aiDelete({
          id
        })
        if (res.code === '0') {
          return Promise.resolve(res.data || '1')
        }
      } catch (error) {
        console.log(error)
        if (DataType.isObject(error) && error.data && error.code === 401) {
          this.$emit('on-logout')
        }
      }
    },

    async onUpdateDialogue(data = {}) {
      try {
        const res = await Api.aiUpdate(data)
        if (res.code === '0') {
          return Promise.resolve(res.data || '1')
        }
      } catch (error) {
        console.log(error)
        if (DataType.isObject(error) && error.data && error.data.code === 401) {
          this.$emit('on-logout')
        }
      }
    },

    //
    async onUpdateDialogueTop(params = {}) {
      try {
        const sourceValue = this.chatSourceType || this.$attrs.sourceType || this.$attrs.source || ''
        const topParams = {
          chatId: params.id
        }
        if (sourceValue === 'global' || sourceValue === 'wenshu') {
          topParams.source = sourceValue
        }
        const res = await Api.aiTop(topParams)
        if (res.code === '0') {
          return Promise.resolve(res.data || '1')
        }
      } catch (error) {
        console.log(error)
      }
    },

    // 取消置顶
    async onUpdateDialogueUnTop(params = {}) {
      try {
        const res = await Api.aiUnTop(params)
        if (res.code === '0') {
          return Promise.resolve(res.data || '1')
        }
      } catch (error) {
        console.log(error)
      }
    },

    async onQueryDialogueDetailById(params = {}) {
      try {
        const res = await Api.aiHistory(params)
        if (res.code === '0') {
          return Promise.resolve(res.data.records || [])
        }
      } catch (error) {
        console.log(error)
        if (DataType.isObject(error) && error.data && error.data.code === 401) {
          this.$emit('on-logout')
        }
      }
    },

    // 停止对话
    async onUpdateDialogueStop(id) {
      try {
        const res = await Api.aiCancel({
          isNeedToken: true,
          messageId:id
        })
        if (res.code === '0') {
          return Promise.resolve(res.data || '1')
        }
      } catch (error) {
        console.log(error)
      }
    },

    async onQueryDialogue({ type, isConcat = false }) {
      try {
        //这里要请求
        // const res = await http.post({
        //     baseURL: window.__apiBaseUrl__,
        //     url: API.queryDialogueList,
        //     isNeedToken: true,
        //     data: {
        //         pageNum: this.pageInfo.pageNum,
        //         pageSize: this.pageInfo.pageSize
        //     }
        // });

        const sourceValue = this.chatSourceType || this.$attrs.sourceType || this.$attrs.source || ''
        const listParams = {
          pageNum: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize,
          resumeId: this.interview.resumeId,
          interviewEvaluateId: this.interview.interviewEvaluateId
        }
        if (sourceValue === 'global' || sourceValue === 'wenshu') {
          listParams.source = sourceValue
        }
        const res = await Api.queryDialogueList(listParams)
        if (res && res.code === '0' && res.data && res.data.records && res.data.records instanceof Array) {
          res.data.list = res.data.records;
          const { list, total, pages } = res.data
          let arr = []
          for (const [e, i] of new Map(list.map((item, i) => [item, i]))) {
            arr.push({
              ...e,
              index: i,
              meta: {
                title: e.chatName,
                level: 2,
                num: null,
                id: e.id,
                fixed: false
              }
            })
          }

          if (type == 'more') {
            let arrData = []
            if (isConcat) {
              arrData = arr.concat(this.dialogueList)
            } else {
              arrData = this.dialogueList.concat(arr)
            }
            // 拼接（增加）

            let obj = {}
            let arrs = arrData.reduce((cur, next) => {
              if (!obj[next['id']]) {
                obj[next['id']] = {
                  index: cur.length
                }
                cur.push(next)
              } else {
                cur.splice(obj[next['id']]['index'], 1, next)
              }
              return cur
            }, []) // 根据Id去重
            this.dialogueList = arrs
          } else {
            // 重置赋值
            this.dialogueList = arr
          }
          this.pageInfo.total = Number(total) || 0
          // let finished =
          //     this.dialogueList.length == total ?
          //     true :
          //     false;
          let finished = this.pageInfo.pageNum >= Number(pages) ? true : false
          this.pageInfo.isMorePage = null
          this.pageInfo.finished = finished
          return Promise.resolve(1)
        }
      } catch (error) {
        console.log(error)
        if (DataType.isObject(error) && error.data && error.data.code === 401) {
          this.$emit('on-logout')
        }
      }
    },

    // 匀速滚动到底
    goBottom(node = document.body) {
      if (!node) {
        return Promise.resolve(true)
      }
      return new Promise((resolve, reject) => {
        let timer = setInterval(() => {
          let isPeed = 300
          node.scrollTop = node.scrollTop + isPeed
          if (Math.ceil(node.scrollTop + node.clientHeight) >= node.scrollHeight) {
            resolve(true)
            clearInterval(timer)
          }
        }, 50)
      })
    }
  }
}
